/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { Ballot, Question, QuestionVoter } from '@src/app/model/ballot';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService, MsgDef } from '@src/app/shared/message.service';
import { catchError, first, map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { uuid } from '@src/app/model/abstract-object';
import { ServiceRequest } from '@src/app/model/serviceRequest';


@Injectable({
  providedIn: 'root'
})
export class BallotService extends AbstractHttpService {
  protected http = inject(HttpClient);
  protected messageService = inject(MessageService);

  protected get baseUrl() {
    return this.getAjaxPath('social/ballots');
  }

  protected cache: Ballot[];
  protected typeString = 'Ballot';

  setSortOrder(ballot: Ballot, questions: Question[], forceTeamId: uuid = null) {
    const send = new Ballot();
    send.id = ballot.id;
    send.questions = [];
    questions.forEach(q => {
      send.questions.push({ id: q.id, question: q.question } as Question)
    })
    console.log({ ballot, send, questions });

    this.http.post(this.baseUrl + '/sort/' + ballot.id, send, this.getSimpleOptions(forceTeamId)).subscribe(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      success => {
        this.messageService.show('Saved...');
        ballot.questions = questions;
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      failure => {
        this.messageService.show(new MsgDef('Not Saved', 'fail'));
      }
    )
  }

  getVoters(ballotId: uuid, questionId: uuid, forceTeamId: uuid = null): Observable<QuestionVoter[]> {
    const url = `${this.baseUrl}/voters/${ballotId}/${questionId}`;
    return this.http.get<QuestionVoter[]>(url, this.getSimpleOptions(forceTeamId))
      .pipe(catchError(this.handleError<QuestionVoter[]>('getVoters', [])));
  }

  notify(object: Ballot, forceTeam: uuid = null) {
    const url = `${this.baseUrl}/notify/${object.id}/${object.revision}`;

    this.http.post(url, object, this.getSimpleOptions(forceTeam)).pipe(
      map((data: Ballot) => {
        if (data) {
          this.messageService.show($localize`OurOMC will send notification mails and mail you to confirm when they have been sent`);
          object.mailsSent = data.mailsSent;
          object.notificationSentAt = data.notificationSentAt;
        }
        return data;
      }),
      catchError(this.handleError('put' + this.typeString))
    ).pipe(first()).subscribe();
  }

  linkRequest(ballot: Ballot, requestId: uuid, forceTeamId: uuid = null): Observable<ServiceRequest> {
    const url = `${this.baseUrl}/${ballot.id}/requests`;
    return this.http.post<ServiceRequest>(url, { requestId }, this.getSimpleOptions(forceTeamId)).pipe(
      tap(() => this.messageService.show($localize`Request linked to this ballot`)),
      catchError(this.handleError<ServiceRequest>('Linking Request', null))
    );
  }

}
